import api from "../../utilities/Interceptor";
import { decrypt } from "../../utilities/Encriptacion";

const url = process.env.REACT_APP_API_KEY

export interface Route {
    ID: number | null;
    NOMBRE: string | null;
    CHOFER: number | null;
    ID_UNIDAD: number | null;
    ID_TRAZO: number | null;
    TIPO: number | null;
    ID_BITACORA: number | null;
}

interface Detail {
    CHOFER: string
    UNIT: string
    OP_IMG: string
    UNIT_IMG: string
}

export const getRoutes = async (id: number, isEntrada: boolean): Promise<Route[]> => {
    const type = isEntrada ? 'E' : 'S';
    const res = await api.get<Route[]>(`${url}/maps/routes/${id}?type=${type}`);
    return res.data;
}

export const getStroke = async (idTrazo: number | null) => {
    const res = await api.get(`${url}/maps/stroke?id_trazo=${idTrazo}`);
    return [res.data];
}

export const getAllStrokes = async (isEntrada: boolean) => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
    const dataClient = sessionStorage.getItem('dataClient');
    const id = decrypt(dataClient, CLAVE);
    const type = isEntrada ? 'E' : 'S';

    const res = await api.get(`${url}/maps/getAllStrokes/${JSON.parse(id).id}?type=${type}`);
    return res.data;
}

export const getUnitPosition = async (id: number, idBitacora: number | null) => {
    const res = await api.get(`${url}/maps/unit?id=${id}&id_bitacora=${idBitacora}`);
    return res.data?.position
        ? { position: res.data.position, unit: `U-${id}`, id }
        : null;
}

export const getDetail = async (id: number): Promise<Detail> => {
    const res = await api.get<Detail>(`${url}/maps/detail/${id}`);
    return res.data;
}
